import React from 'react';
import classNames from 'classnames';
import { Tooltip } from '../Tooltip/Tooltip';
/**
 * Bronson [Info Icon](https://bronson.vwfs.io/bluelabel/components/detail/bronson-info-icon--info-icon.html) component.
 */
export function InfoIcon({ children, className, element = 'button', icon, tippyProps, testId, ...otherProps }) {
    const CustomElement = `${element}`;
    const buttonClassNameList = classNames('c-icon', 'c-info-icon', {
        [`c-icon--[${icon}]`]: icon,
    }, className).trim();
    const typeProp = element === 'button' ? { type: 'button' } : {};
    return (React.createElement(Tooltip, { content: children, ...tippyProps, __internalDisableTooltipClass: true },
        React.createElement(CustomElement, { ...otherProps, "data-testid": testId, ...typeProp, className: buttonClassNameList, "data-tippy-content": children, "data-tippy-placement": children && 'top' })));
}
